import React, { useId } from 'react';
import './SkinArtwork.css';

const OrbitalArtwork = ({ id, paint }) => (
  <svg viewBox="0 0 500 350" fill="none" focusable="false">
    <defs>
      <radialGradient id={`${id}-orbital-haze`}>
        <stop stopColor="#c8d9fa" stopOpacity=".55" />
        <stop offset="1" stopColor="#c8d9fa" stopOpacity="0" />
      </radialGradient>
      <radialGradient id={`${id}-orbital-planet`} gradientUnits="userSpaceOnUse" cx="0" cy="0" r="1" gradientTransform="translate(231 138) rotate(53) scale(142)">
        <stop stopColor="#c5e9ef" />
        <stop offset=".38" stopColor="#83afcf" />
        <stop offset=".75" stopColor="#516b9c" />
        <stop offset="1" stopColor="#2f3d70" />
      </radialGradient>
      <linearGradient id={`${id}-orbital-ring`} x1="115" y1="228" x2="411" y2="110" gradientUnits="userSpaceOnUse">
        <stop stopColor="#9bc5d9" stopOpacity=".2" />
        <stop offset=".38" stopColor="#f9e4b9" />
        <stop offset=".7" stopColor="#d8d1c6" />
        <stop offset="1" stopColor="#8aafd2" stopOpacity=".25" />
      </linearGradient>
      <filter id={`${id}-orbital-shadow`} x="-40%" y="-40%" width="180%" height="180%">
        <feDropShadow dx="0" dy="17" stdDeviation="17" floodColor="#435486" floodOpacity=".25" />
      </filter>
    </defs>

    <circle cx="255" cy="169" r="155" fill={paint('orbital-haze')} />
    <ellipse cx="250" cy="174" rx="205" ry="104" transform="rotate(-19 250 174)" stroke="#789fc6" strokeOpacity=".46" strokeWidth="1" strokeDasharray="3 8" />
    <ellipse cx="250" cy="174" rx="188" ry="91" transform="rotate(23 250 174)" stroke="#a3b8d0" strokeOpacity=".26" strokeWidth="1" strokeDasharray="1 11" />
    <g className="skin-artwork__orbital-world">
      <ellipse cx="263" cy="177" rx="161" ry="48" transform="rotate(-19 263 177)" stroke={paint('orbital-ring')} strokeWidth="13" />
      <ellipse cx="263" cy="177" rx="160" ry="48" transform="rotate(-19 263 177)" stroke="#f9ebd0" strokeOpacity=".72" strokeWidth="1.6" />
      <circle cx="263" cy="176" r="72" fill={paint('orbital-planet')} filter={paint('orbital-shadow')} />
      <path d="M214 123c18-19 43-28 67-23M207 138c11-12 21-17 32-20" stroke="#ebfbf9" strokeOpacity=".55" strokeWidth="2" strokeLinecap="round" />
      <path d="M228 225c25 11 61 8 87-11" stroke="#263e76" strokeOpacity=".22" strokeWidth="3" strokeLinecap="round" />
      <path d="M111 229c54 35 156 32 228-8 36-20 60-51 76-96" stroke={paint('orbital-ring')} strokeWidth="12" strokeLinecap="round" />
      <path d="M111 225c56 34 156 29 226-9 34-19 59-49 76-88" stroke="#fff2d8" strokeOpacity=".7" strokeWidth="1.6" strokeLinecap="round" />
    </g>

    <g fill="#f5dca8">
      <circle cx="105" cy="86" r="3" />
      <circle cx="389" cy="64" r="2" />
      <circle cx="420" cy="252" r="2.5" />
    </g>
    <g className="skin-artwork__orbital-twinkle" stroke="#f6dfad" strokeLinecap="round">
      <path d="M78 155v13m-6.5-6.5h13M379 276v11m-5.5-5.5h11M348 58v8m-4-4h8" strokeWidth="1.5" />
      <circle cx="151" cy="290" r="1.7" fill="#9ec4d8" stroke="none" />
    </g>
    <path d="M78 98h49m-49 0v-9M368 272h52m0 0v-8" stroke="#7a92b5" strokeOpacity=".6" strokeWidth="1" />
    <g fill="#667da8" fontFamily="ui-monospace, SFMono-Regular, Consolas, monospace" fontSize="9" letterSpacing="2">
      <text x="78" y="82">POLARIS / 004</text>
      <text x="370" y="291">ORBIT · 07</text>
    </g>
  </svg>
);

const TerminalArtwork = ({ id, paint }) => (
  <svg viewBox="0 0 500 350" fill="none" focusable="false">
    <defs>
      <linearGradient id={`${id}-terminal-window`} x1="76" y1="54" x2="391" y2="304" gradientUnits="userSpaceOnUse">
        <stop stopColor="#ffffff" />
        <stop offset="1" stopColor="#f5f7f4" />
      </linearGradient>
      <linearGradient id={`${id}-terminal-screen`} x1="107" y1="112" x2="399" y2="265" gradientUnits="userSpaceOnUse">
        <stop stopColor="#ffffff" />
        <stop offset="1" stopColor="#fafcf9" />
      </linearGradient>
      <filter id={`${id}-terminal-shadow`} x="-20%" y="-30%" width="150%" height="170%">
        <feDropShadow dx="0" dy="17" stdDeviation="16" floodColor="#293639" floodOpacity=".24" />
      </filter>
    </defs>

    <circle cx="243" cy="178" r="157" fill="#c6d2ca" fillOpacity=".18" />
    <path d="M67 267h57m268-188h42M406 267h36" stroke="#9abdb0" strokeOpacity=".6" strokeWidth="1" />
    <g className="skin-artwork__terminal-window">
      <rect x="76" y="53" width="349" height="247" rx="10" fill={paint('terminal-window')} stroke="#9aa5a0" strokeWidth="1.5" filter={paint('terminal-shadow')} />
      <path d="M76 63c0-5.5 4.5-10 10-10h329c5.5 0 10 4.5 10 10v25H76V63Z" fill="#eef1f5" />
      <path d="M76 88h349" stroke="#d8dfe7" />
      <circle cx="95" cy="70" r="5" fill="#ff6059" />
      <circle cx="112" cy="70" r="5" fill="#ffbd2e" />
      <circle cx="129" cy="70" r="5" fill="#28ca42" />
      <text x="211" y="73" fill="#66778c" fontFamily="ui-monospace, SFMono-Regular, Consolas, monospace" fontSize="10">a quiet workspace</text>
      <g fontFamily="ui-monospace, SFMono-Regular, Consolas, monospace" fontSize="12" letterSpacing=".2">
        <text x="96" y="117" fill="#77817c" fontSize="10">Last login: today, from a little cloud</text>
        <text x="96" y="149" fill="#25352b"><tspan fill="#3e8c55">visitor@journal</tspan> ~ % open today</text>
        <text x="96" y="177" fill="#67736b">reading notes · collecting moments</text>
        <path d="m97 201 4 4 8-9" stroke="#4e795b" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
        <text x="118" y="205" fill="#4e795b">a little space for big ideas</text>
        <text x="96" y="243" fill="#25352b"><tspan fill="#3e8c55">visitor@journal</tspan> ~ %</text>
      </g>
      <rect className="skin-artwork__terminal-caret" x="242" y="231" width="8" height="15" fill="#33493a" />
    </g>
    <g>
      <rect x="325" y="274" width="112" height="29" rx="7" fill="#e8eef7" stroke="#c0cdde" />
      <path d="m341 284-4 4 4 4m9-8 4 4-4 4m-5-10-2 12" stroke="#5c79a0" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
      <text x="364" y="292" fill="#5c79a0" fontFamily="ui-monospace, SFMono-Regular, Consolas, monospace" fontSize="10">curiosity</text>
    </g>
  </svg>
);

const AtelierArtwork = ({ id, paint }) => (
  <svg viewBox="0 0 500 350" fill="none" focusable="false">
    <defs>
      <linearGradient id={`${id}-atelier-paper`} x1="137" y1="73" x2="370" y2="256" gradientUnits="userSpaceOnUse">
        <stop stopColor="#fffdf5" />
        <stop offset="1" stopColor="#faf3e4" />
      </linearGradient>
      <linearGradient id={`${id}-atelier-envelope`} x1="106" y1="177" x2="391" y2="309" gradientUnits="userSpaceOnUse">
        <stop stopColor="#f8efde" />
        <stop offset="1" stopColor="#eadbc2" />
      </linearGradient>
      <linearGradient id={`${id}-atelier-flap`} x1="250" y1="63" x2="250" y2="183" gradientUnits="userSpaceOnUse">
        <stop stopColor="#f6ead6" />
        <stop offset="1" stopColor="#e8d6b8" />
      </linearGradient>
      <filter id={`${id}-atelier-shadow`} x="-20%" y="-20%" width="140%" height="155%">
        <feDropShadow dx="0" dy="9" stdDeviation="9" floodColor="#8e7050" floodOpacity=".11" />
      </filter>
    </defs>

    <g className="skin-artwork__atelier-sheet">
      <g transform="rotate(-5 250 183)" filter={paint('atelier-shadow')}>
        {/* The raised envelope flap sits behind a loose sheet of letter paper. */}
        <path d="M94 166 240 64c7-5 15-5 22 0l148 102v128a9 9 0 0 1-9 9H103a9 9 0 0 1-9-9V166Z" fill={paint('atelier-envelope')} stroke="#cfb999" strokeWidth="1.1" />
        <path d="m95 166 145-102c7-5 15-5 22 0l147 102-157 101L95 166Z" fill={paint('atelier-flap')} stroke="#d4bea0" strokeWidth="1" />

        <g transform="rotate(3 251 171)">
          <rect x="135" y="73" width="232" height="193" rx="2" fill={paint('atelier-paper')} stroke="#dfd0b6" />
          <path d="M145 82h212" stroke="#fffefa" strokeWidth="2" />
          <text x="156" y="104" fill="#a18a71" fontFamily="Georgia, serif" fontSize="9" letterSpacing="2.2">LETTER TO YOU</text>
          <text x="156" y="135" fill="#7a6553" fontFamily="Georgia, serif" fontSize="21" fontStyle="italic">Dear reader,</text>
          <path d="M157 157c43-1 106-1 160 0m-160 17c54-.5 105-.5 152 0m-152 17c43-.5 76-.5 113 0" stroke="#bca88c" strokeWidth="1.1" strokeLinecap="round" />
          <path d="M157 217c9-5 17-5 25-1 7 3 11 3 19 0m-13 6 30-4" stroke="#927d65" strokeWidth="1.1" strokeLinecap="round" />

          {/* A small botanical stamp, drawn in ink rather than a solid badge. */}
          <rect x="311" y="91" width="37" height="47" rx="1" stroke="#b9b598" strokeDasharray="2 2" />
          <path d="M316 96h27v37h-27z" stroke="#d6d3ba" strokeWidth=".8" />
          <path d="M329 126c-1-10 0-17 4-25m-4 17c-8-1-11-6-9-10 7 1 10 5 9 10Zm1-6c7 0 10-4 10-8-6 0-9 3-10 8Z" stroke="#8f9979" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
        </g>

        {/* Two side folds and the lower fold make the open envelope unmistakable. */}
        <path d="m95 167 157 100L104 302c-5 0-10-4-10-9V167Z" fill="#f0e3cd" stroke="#d5c1a3" strokeWidth="1" strokeLinejoin="round" />
        <path d="m409 167-157 100 148 35c6 0 10-4 10-9V167Z" fill="#f8edda" stroke="#d5c1a3" strokeWidth="1" strokeLinejoin="round" />
        <path d="m97 299 132-83c14-9 31-9 45 0l133 83c-2 3-5 4-9 4H106c-4 0-7-1-9-4Z" fill={paint('atelier-envelope')} stroke="#cfb999" strokeWidth="1" strokeLinejoin="round" />
        <path d="m108 298 123-77c13-8 28-8 41 0l123 77" stroke="#fff9ec" strokeOpacity=".7" strokeWidth="1" />
        <text x="121" y="277" fill="#957b5f" fontFamily="Georgia, serif" fontSize="12" fontStyle="italic">a little thought, shared.</text>

        <g transform="rotate(12 339 263)" stroke="#a79070" strokeOpacity=".7" strokeWidth="1" strokeLinecap="round">
          <circle cx="338" cy="261" r="23" />
          <circle cx="338" cy="261" r="18.5" strokeDasharray="1 3" />
          <path d="M331 272c6-7 9-14 12-22m-8 17c-7-2-9-5-8-9 6 1 9 4 8 9Zm3-8c6 1 10-2 11-6-6-2-10 1-11 6Z" stroke="#859074" />
          <path d="M361 252c8-4 16 4 24 0m-24 8c8-4 16 4 24 0m-24 8c8-4 16 4 24 0" />
        </g>
      </g>
    </g>
  </svg>
);

/** Decorative illustration for one of the three non-default skins. */
const SkinArtwork = ({ skin = 'orbital', className = '', ...props }) => {
  const id = `skin-art-${useId().replace(/:/g, '')}`;
  const paint = name => `url(#${id}-${name})`;
  const artworkProps = { id, paint };

  return (
    <div className={`skin-artwork skin-artwork--${skin} ${className}`.trim()} aria-hidden="true" {...props}>
      {skin === 'terminal' ? <TerminalArtwork {...artworkProps} /> :
        skin === 'atelier' ? <AtelierArtwork {...artworkProps} /> :
          <OrbitalArtwork {...artworkProps} />}
    </div>
  );
};

export default SkinArtwork;
